import React, { useContext, useEffect } from "react";
import styles from "./Home.module.css";
import { lapContext } from "../../context/OverLapContext";
import { useNavigate } from "react-router-dom";

function Home() {
  const { user, setUser, setIsUserActive } = useContext(lapContext);
  const navigate = useNavigate();
  useEffect(() => {
    async function getUser() {
      try {
        const result = await fetch(
          `https://artmadein-dashboard-backend.onrender.com/api/v1/user/userdata`,
          // `http://localhost:5000/api/v1/user/userdata`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );
        if (result.status === 401) {
          sessionStorage.clear();
          navigate("/login");
        }
        setIsUserActive(result.ok);
        const final = await result.json();
        setUser(final.data);
      } catch (err) {
        console.log("You are not Login", err);
      }
    }

    getUser();
  }, [setUser, setIsUserActive, navigate]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.box}>
          <h1>
            Welcome, <span>{user.fullName}</span>
          </h1>
          <div className={styles.home}>
            <div className={styles.avatarBox}>
              <img src={user.avatar} alt={user.fullName}></img>
            </div>
            <div className={styles.userBox}>
              <p>{user.userType}</p>
              <p>{user.email}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
